"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerDTOSchema = void 0;
const AvatarCompositionDTO_1 = require("./AvatarCompositionDTO");
const ETeam_1 = require("./ETeam");
const zod_1 = require("zod");
const PlayerDTOSchema = zod_1.z.object({
    micOn: zod_1.z.boolean(),
    name: zod_1.z.string(),
    avatarComposition: AvatarCompositionDTO_1.AvatarCompositionDTOSchema,
    team: zod_1.z.nativeEnum(ETeam_1.ETeam),
    capitain: zod_1.z.boolean(),
    sessionPeerId: zod_1.z.string(),
    mediaAPIPeerId: zod_1.z.string().optional(),
    isConnected: zod_1.z.boolean(),
});
exports.PlayerDTOSchema = PlayerDTOSchema;
